var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotificationHighRisk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#FFE9E5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 30C25.5228 30 30 25.5228 30 20C30 14.4772 25.5228 10 20 10C14.4772 10 10 14.4772 10 20C10 25.5228 14.4772 30 20 30ZM20 15C20.5523 15 21 15.4477 21 16V20C21 20.5523 20.5523 21 20 21C19.4477 21 19 20.5523 19 20V16C19 15.4477 19.4477 15 20 15ZM20 23C19.4477 23 19 23.4477 19 24C19 24.5523 19.4477 25 20 25H20.01C20.5623 25 21.01 24.5523 21.01 24C21.01 23.4477 20.5623 23 20.01 23H20Z",
    fill: "#E7514F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationHighRisk);
export default __webpack_public_path__ + "static/media/notification-high-risk.3216b21d60df55a64fccd695387549c1.svg";
export { ForwardRef as ReactComponent };